import {useSelector} from "react-redux";
import {MenuItemDetails} from "./menu/menu-item-details/MenuItemDetails";
import {Menu} from "./menu/Menu";
import {notifyViewEvent, setMenuItems} from "../slices/statisticsSlice";
import {useAppDispatch} from "../hooks/hooks.ts";
import {useCallback, useEffect} from "react";
import {useParams} from "react-router-dom";
import type {RootState} from "../store/store.ts";
import {executePostScanActions} from "../slices/postScanSlice.ts";
import {setScanCompleted} from "../slices/mainSlice.ts";
import {AppSkeleton} from "./menu/loading-skeletons/AppSkeleton.tsx";

export const ViewsController = () => {
    const dispatch = useAppDispatch();
    const {
        menuItem,
        restaurantToken,
        scanCompleted
    } = useSelector<any, any>((s: RootState) => s.main.view);
    const {menuItems} = useSelector<any, any>((s: RootState) => s.statistics.menuItemViews);
    const {isLoading: isMenuLoading} = useSelector<any, any>((state: RootState) => state.main.getMenu);

    const {preview} = useParams();

    const notifyMenuItemViewEvent = useCallback(() => {
        if (!menuItem) return;

        if (!menuItems.includes(menuItem.id)) {
            dispatch(setMenuItems([...menuItems, menuItem.id]));
            dispatch(notifyViewEvent({menuItemId: menuItem.id}));
        }
    }, [dispatch, menuItem, menuItems]);

    const notifyScanEvent = useCallback(() => {
        if (scanCompleted) return;
        if (!restaurantToken || restaurantToken === '') return;
        dispatch(executePostScanActions(restaurantToken));
        dispatch(setScanCompleted(true));
    }, [dispatch, restaurantToken, scanCompleted]);

    useEffect(() => {
        const isPreview = preview === 'true';
        if (isPreview) return;
        notifyMenuItemViewEvent();
        notifyScanEvent();
    }, [notifyMenuItemViewEvent, notifyScanEvent, preview]);

    useEffect(() => {
        window.parent.postMessage({type: 'PREVIEW_READY', source: 'menu-preview'}, '*');
    }, []);

    if (isMenuLoading) return <AppSkeleton/>

    return menuItem ? <MenuItemDetails/> : <Menu/>;
};